import coverS100 from '@/assets/producets/S-100.png'
import coverS300 from '@/assets/producets/S-300.png'
import coverS800 from '@/assets/producets/S-800.png'
import coverSN900 from '@/assets/producets/SN-900.png'
import s100View1 from '@/assets/producets/S-100/1.png'
import s100View2 from '@/assets/producets/S-100/2.png'
import s100View3 from '@/assets/producets/S-100/3.png'
import s100View4 from '@/assets/producets/S-100/4.png'
import s300View1 from '@/assets/producets/S-300/1.png'
import s300View2 from '@/assets/producets/S-300/2.png'
import s300View3 from '@/assets/producets/S-300/3.png'
import s300View4 from '@/assets/producets/S-300/4.png'
import s800View1 from '@/assets/producets/S-800/1.png'
import s800View2 from '@/assets/producets/S-800/2.png'
import s800View3 from '@/assets/producets/S-800/3.png'
import s800View4 from '@/assets/producets/S-800/4.png'
import sn900View1 from '@/assets/producets/SN-900/1.png'
import sn900View2 from '@/assets/producets/SN-900/2.png'
import sn900View3 from '@/assets/producets/SN-900/3.png'
import sn900View4 from '@/assets/producets/SN-900/4.png'

export type Product = {
  cover: string
  views: string[]
  title: string
  description: string
}

export const products: Product[] = [
  {
    cover: coverS100,
    views: [s100View1, s100View2, s100View3, s100View4],
    title: 'S-100',
    description: '20USDT|64GB+ RAM|7200rpm|Xeon|2TFLOPS',
  },
  {
    cover: coverS300,
    views: [s300View1, s300View2, s300View3, s300View4],
    title: 'S-300',
    description: '90USDT|128GB+ RAM|7200rpm|Xeon|10TFLOPS',
  },
  {
    cover: coverS800,
    views: [s800View1, s800View2, s800View3, s800View4],
    title: 'S-800',
    description: '320USDT|256GB+ RAM|7200rpm|Xeon|35TFLOPS',
  },
  {
    cover: coverSN900,
    views: [sn900View1, sn900View2, sn900View3, sn900View4],
    title: 'SN-900',
    description: '800USDT|512GB+ RAM|7200rpm|Xeon|90TFLOPS',
  },
]
